"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Star } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const reviews = [{
    quote: "La professionalità e l'umanità del Dott. Colloca mi hanno accompagnata nel percorso più importante della mia vita.",
    author: "Elena V.",
    role: "Paziente",
    date: "15 MAR 2025",
    initials: "EV",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/paziente_elena_ritratto.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/paziente_elena_ritratto.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/paziente_elena_ritratto.png-wvc-sizes"
  }, {
    quote: "Un esperto di rara competenza. La sua chiarezza nella spiegazione di tematiche complesse è stata fondamentale.",
    author: "Marco R.",
    role: "Paziente",
    date: "02 FEB 2025",
    initials: "MR",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/paziente_marco_ritratto.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/paziente_marco_ritratto.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/paziente_marco_ritratto.webp-wvc-sizes"
  }, {
    quote: "Grazie alla sua dedizione e alla profonda conoscenza della fisiopatologia, ho finalmente trovato risposte concrete.",
    author: "Giulia S.",
    role: "Paziente",
    date: "21 GEN 2025",
    initials: "GS",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/paziente_giulia_ritratto.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/paziente_giulia_ritratto.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/paziente_giulia_ritratto.webp-wvc-sizes"
  }];
  return <section data-section-id="1693" id="esperienze-dei-pazienti" className="bg-background text-foreground relative overflow-hidden py-28 md:py-40">
      <div className="mx-auto w-full max-w-[1320px] px-5 sm:px-8 lg:px-14">
        {}
        <div ref={headerRef} className={`relative grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <div aria-hidden="true" className="pointer-events-none absolute -top-8 left-0 lg:left-[-1rem] font-serif font-light leading-none select-none" style={{
          fontSize: "clamp(8rem, 16vw, 14rem)",
          color: "transparent",
          WebkitTextStroke: "1px hsl(215 25% 15% / 0.1)",
          opacity: 0.4
        }}>
            04
          </div>

          {}
          <div className="lg:col-span-9 relative z-10 order-2 lg:order-1">
            {}
            <div className="flex items-center gap-4 mb-8">
              <span className="font-mono text-[11px] sm:text-[13px] uppercase tracking-[0.18em] font-medium" style={{
              color: "hsl(215 25% 15%)"
            }}>
                § N° 04 — Esperienze dei Pazienti · Testimonianze
              </span>
            </div>
            <div className="flex items-center gap-2 mb-10">
              <span className="h-px w-14" style={{
              backgroundColor: "hsl(350 70% 65%)"
            }} />
              <span className="size-1 rounded-lg" style={{
              backgroundColor: "hsl(350 70% 65%)"
            }} />
            </div>

            {}
            <h2 className="font-default font-normal leading-[0.98] tracking-tight" style={{
            fontSize: "clamp(2.25rem, 4.6vw, 4.25rem)",
            color: "hsl(215 25% 15%)"
          }}>
              La fiducia dei pazienti,{" "}
              <em className="italic relative inline-block" style={{
              color: "hsl(350 70% 65%)"
            }}>
                costruita
                <span className={`absolute left-0 -bottom-2 h-px transition-all duration-700 ease-out ${headerVisible ? "w-full" : "w-0"}`} style={{
                backgroundColor: "hsl(350 70% 65%)",
                transitionDelay: "300ms"
              }} />
              </em>{" "}
              con cura.
            </h2>
          </div>

          {}
          <div className="lg:col-span-3 relative z-10 order-1 lg:order-2 flex flex-col items-start lg:items-end lg:text-right">
            <div className="font-default font-light leading-none" style={{
            fontSize: "5rem",
            color: "hsl(350 70% 65%)"
          }}>
              5.0
            </div>
            <div className="flex items-center gap-1 mt-4 mb-4">
              {[0, 1, 2, 3, 4].map(i => <Star key={i} data-index={i} className="size-5" style={{
              color: "hsl(350 70% 65%)",
              fill: "hsl(350 70% 65%)"
            }} />)}
            </div>
            <span className="font-mono text-[11px] uppercase tracking-[0.18em] font-medium" style={{
            color: "hsl(215 10% 45%)"
          }}>
              Recensioni verificate · Aggiornate mensilmente
            </span>
          </div>
        </div>

        {}
        <div ref={cardsRef} className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {reviews.map((review, i) => <Card key={i} data-index={i} className={`group relative rounded-lg p-9 transition-all duration-500 ease-out hover:-translate-y-1 ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          backgroundColor: "hsl(0 0% 100%)",
          border: "1px solid hsl(215 15% 90%)",
          transitionDelay: `${i * 120}ms`,
          color: "hsl(215 25% 15%)"
        }}>
              {}
              <span aria-hidden="true" className="absolute top-3 left-4 font-mono text-[11px]" style={{
            color: "hsl(215 10% 45%)"
          }}>
                [ § 01 ]
              </span>
              <span aria-hidden="true" className="absolute top-3 right-4 font-mono text-[11px]" style={{
            color: "hsl(215 10% 45%)"
          }}>
                [ CLINICAL ]
              </span>

              {}
              <div className="flex items-center gap-3 mb-7">
                <div className="flex items-center gap-0.5">
                  {[0, 1, 2, 3, 4].map(s => <Star key={s} className="size-3.5" style={{
                color: "hsl(350 70% 65%)",
                fill: "hsl(350 70% 65%)"
              }} />)}
                </div>
                <span className="font-mono text-[11px] uppercase tracking-[0.18em] font-medium" style={{
              color: "hsl(215 10% 45%)"
            }}>
                  · Paziente
                </span>
              </div>

              {}
              <blockquote className="font-default italic font-normal leading-snug" style={{
            fontSize: "clamp(1.25rem, 1.6vw, 1.5rem)",
            color: "hsl(215 25% 15%)"
          }}>
                &ldquo;{review.quote}&rdquo;
              </blockquote>

              {}
              <div className="flex items-center gap-2 mt-8 mb-6">
                <span className="size-1 rounded-lg" style={{
              backgroundColor: "hsl(350 70% 65%)"
            }} />
                <span className="h-px w-10" style={{
              backgroundColor: "hsl(350 70% 65%)"
            }} />
              </div>

              {}
              <div className="flex items-center gap-4">
                <SafeHydrate><Avatar className="size-10 rounded-lg" style={{
                backgroundColor: "hsl(215 15% 94%)"
              }}>
                  <AvatarImage src={review.avatar} data-wvc-srcset={review.srcset} data-wvc-sizes={review.sizes} alt={review.author} loading="lazy" />
                  <AvatarFallback className="font-mono text-xs" style={{
                  backgroundColor: "hsl(215 15% 94%)",
                  color: "hsl(215 25% 15%)"
                }}>
                    {review.initials}
                  </AvatarFallback>
                </Avatar></SafeHydrate>
                <div className="flex flex-col">
                  <span className="font-default font-semibold text-base" style={{
                color: "hsl(215 25% 15%)"
              }}>
                    {review.author}
                  </span>
                  <span className="font-mono text-[11px] uppercase tracking-[0.08em] mt-0.5" style={{
                color: "hsl(215 10% 45%)"
              }}>
                    {review.date}
                  </span>
                </div>
              </div>
            </Card>)}
        </div>

        {}
        <div className="mt-16 flex items-center gap-2">
          <span className="font-mono text-[11px]" style={{
          color: "hsl(215 10% 45%)"
        }}>
            [ CLINICAL_PRECISION // 2025 ]
          </span>
        </div>
      </div>
    </section>;
}